export default __webpack_public_path__ + "static/media/kubernetes.863617bc.svg";